import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { receive, getCustomerSale, getCardReceiveDetail, cardManagementCreate, getLastCardNumber } from '../api/index.js';
import { getBusinessType as _getBusinessType, getSearchCardType } from '@/api/order.js';
import { parseTime } from '@/utils/index.js';
import CardDemandMaterialSelectDrawer from './cardDemandMaterialSelectDrawer.vue';
export default {
  name: 'CardReceiveRegisterDrawer',
  components: {
    CardDemandMaterialSelectDrawer: CardDemandMaterialSelectDrawer
  },
  props: {
    // 列表行数据（领取/编辑时传入，新建领卡登记时为 null）
    row: {
      type: Object,
      default: null
    },
    // create：外部领卡登记按钮新建 receive：列表领取 edit：列表编辑
    mode: {
      type: String,
      default: 'create'
    }
  },
  data: function data() {
    return {
      submitLoading: false,
      loading: false,
      drawerSelect: false,
      businessTypeList: [],
      // 业务类型
      cardTypeList: [],
      // 卡类型
      activeName: '0',
      form: {
        id: '',
        // 数据id（领取时详情接口返回）
        customer_id: '',
        // 客户ID
        sale_user_id: '',
        // 领用人ID
        user_name: '',
        // 领用人
        card_bin_group_id: '',
        // 业务类型ID
        card_type: '',
        // 卡类型
        expected_card_date: '',
        // 预计领卡日期
        expected_card_time: '11:00',
        // 预计领卡时间
        card_date: '',
        // 领卡日期
        card_time: '',
        // 领卡时间
        note: '',
        // 备注
        material_arr: []
      }
    };
  },
  computed: {
    // 明细中已存在的卡券物料类型（material_type 1：PVC卡 2：券）
    existingCardCouponTypes: function existingCardCouponTypes() {
      return (this.form.material_arr || []).map(function (item) {
        return String(item.material_type);
      }).filter(function (type) {
        return type === '1' || type === '2';
      });
    }
  },
  created: function created() {
    this.getBusinessType();
    var today = parseTime(new Date(), '{y}-{m}-{d}');
    // 新建领卡登记：预计领卡日期/领卡日期回显当前天，领卡时间回显当前时间
    if (this.mode === 'add') {
      this.form.expected_card_date = today;
      this.form.card_date = today;
    }
    this.form.card_time = new Date();
    // 领取模式：根据数据id获取详情回显
    if (this.mode === 'receive' && this.row) {
      this.getDetail();
    }
  },
  methods: {
    // 获取领卡详情并回显表单
    getDetail: function getDetail() {
      var _this = this;
      this.loading = true;
      getCardReceiveDetail({
        id: this.row.id
      }).then(function (res) {
        var data = res.data || {};
        var info = data.info || {};
        _this.form.id = info.id;
        _this.form.customer_id = info.customer_id || '';
        _this.form.sale_user_id = info.sale_user_id || '';
        _this.form.user_name = info.sale_user_name || info.user_name || '';
        _this.form.card_bin_group_id = info.card_bin_group_id || '';
        _this.form.card_type = info.card_type || '';
        _this.form.expected_card_date = info.expected_card_date;
        _this.form.expected_card_time = info.expected_card_time || '';
        _this.form.card_date = info.card_date || '';
        _this.form.note = info.note || '';
        _this.form.material_arr = (data.material_arr || []).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            begin_code: item.begin_code && item.begin_code !== '0' ? item.begin_code : '',
            end_code: item.end_code && item.end_code !== '0' ? item.end_code : ''
          });
        });
        // 回显卡类型下拉：先按业务类型拉取卡类型列表，再回填
        if (_this.form.card_bin_group_id && info.card_type) {
          _this.getCardTypeList(_this.form.card_bin_group_id);
        }
      }).catch(function () {
        _this.$message.error('获取领卡详情失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    // 是否卡券物料（PVC卡/券）
    isCardCoupon: function isCardCoupon(item) {
      var type = Number(item.material_type);
      return type === 1 || type === 2;
    },
    // 客户ID失焦，根据客户ID获取领用人
    handleCustomerBlur: function handleCustomerBlur() {
      var _this2 = this;
      var customerId = String(this.form.customer_id || '').trim();
      this.form.user_name = '';
      this.form.sale_user_id = '';
      if (!customerId || !/^[1-9]\d*$/.test(customerId)) return;
      getCustomerSale({
        customer_id: customerId
      }).then(function (res) {
        _this2.form.sale_user_id = res.data && res.data.sale_user_id || '';
        _this2.form.user_name = res.data && res.data.sale_user_name || '';
      }).catch(function () {
        _this2.form.sale_user_id = '';
        _this2.form.user_name = '';
      });
    },
    // 卡序号输入清洗：去除所有非数字字符（含粘贴带入的不可见字符）
    handleCodeInput: function handleCodeInput(item, field) {
      var cleaned = String(item[field] || '').replace(/[^0-9]/g, '');
      this.$set(item, field, cleaned);
    },
    // 是否可点击计算：开始卡序号为16位数字且申请数量有效
    canCalc: function canCalc(row) {
      return /^\d{16}$/.test(String(row.begin_code || '')) && Number(row.apply_num) > 0;
    },
    // 计算：开始卡序号+申请数量调接口获取结束卡序号并回填，再算出领取数量
    calcEndCode: function calcEndCode(item) {
      var _this3 = this;
      var begin = String(item.begin_code || '').trim();
      if (!/^\d{16}$/.test(begin)) {
        this.$message.warning('请先输入16位开始卡序号');
        return;
      }
      var number = Number(item.apply_num);
      if (!number || number <= 0) {
        this.$message.warning('申请数量无效，无法计算结束卡序号');
        return;
      }
      this.$set(item, 'calc_loading', true);
      getLastCardNumber({
        begin_code: begin,
        number: number
      }).then(function (res) {
        var end = String(res.data && res.data.end_code || '').trim();
        if (!end) {
          _this3.$message.warning('获取结束卡序号失败');
          return;
        }
        _this3.$set(item, 'end_code', end);
        _this3.calcReceiveNum(item);
      }).catch(function () {}).finally(function () {
        _this3.$set(item, 'calc_loading', false);
      });
    },
    // 光标离开起止卡序号/结束卡序号，自动算出领取数量
    handleCodeBlur: function handleCodeBlur(item) {
      var begin = String(item.begin_code || '').trim();
      var end = String(item.end_code || '').trim();
      // 任一项未填写时不触发计算
      if (!begin || !end) return;
      if (!/^\d{16}$/.test(begin) || !/^\d{16}$/.test(end)) {
        this.$message.warning('起止卡序号必须为16位数字');
        return;
      }
      this.calcReceiveNum(item);
    },
    // 计算领取数量（止 - 起 + 1），领取数量不可修改
    calcReceiveNum: function calcReceiveNum(item) {
      var begin = String(item.begin_code || '').trim();
      var end = String(item.end_code || '').trim();
      // 等长字符串比较即为数值比较
      if (end < begin) {
        this.$message.warning('结束卡序号不能小于开始卡序号');
        item.receive_num = '';
        return;
      }
      // 领取数量 = 止 - 起 + 1
      item.receive_num = String(Number(end) - Number(begin) + 1);
    },
    // 获取业务类型
    getBusinessType: function getBusinessType() {
      var _this4 = this;
      _getBusinessType().then(function (res) {
        _this4.businessTypeList = res.data;
      });
    },
    // 根据业务类型获取卡类型
    getCardTypeList: function getCardTypeList(businessId) {
      var _this5 = this;
      getSearchCardType({
        version: 2,
        business_id: businessId
      }).then(function (res) {
        _this5.cardTypeList = res.data;
      });
    },
    // 切换业务类型，联动清空卡类型
    changeBusinessType: function changeBusinessType(val) {
      this.form.card_type = '';
      this.cardTypeList = [];
      if (val) {
        this.getCardTypeList(val);
      }
    },
    // 校验卡/券类型物料数量（material_type 1：PVC卡 2：券，最多1个）
    checkCardMaterialLimit: function checkCardMaterialLimit(items) {
      var _this6 = this;
      var count = (items || []).filter(function (item) {
        return _this6.isCardCoupon(item);
      }).length;
      if (count > 1) {
        this.$message.error('只能提交1个卡/券类型的物料');
        return false;
      }
      return true;
    },
    // 打开添加物料抽屉
    handleAddMaterial: function handleAddMaterial() {
      this.drawerSelect = true;
    },
    // 添加物料确认回调，追加到明细（已存在的物料不重复添加）
    handleMaterialSelected: function handleMaterialSelected(materials) {
      var existIds = this.form.material_arr.map(function (item) {
        return String(item.id);
      });
      var list = (materials || []).filter(function (item) {
        return !existIds.includes(String(item.id));
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          begin_code: '',
          end_code: '',
          receive_num: ''
        });
      });
      if (!list.length) {
        this.$message.warning('所选物料均已添加，请勿重复选择');
        return;
      }
      var merged = [].concat(_toConsumableArray(this.form.material_arr), _toConsumableArray(list));
      if (!this.checkCardMaterialLimit(merged)) return;
      this.form.material_arr = merged;
      this.drawerSelect = false;
    },
    // 移除物料
    handleRemove: function handleRemove(index) {
      this.form.material_arr.splice(index, 1);
    },
    // 提交
    submitForm: function submitForm() {
      var _this7 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        if (_this7.form.material_arr.length === 0) {
          _this7.$message.warning('请至少添加一个物料');
          return;
        }
        if (!_this7.checkCardMaterialLimit(_this7.form.material_arr)) return;
        // 申请数量与领取数量不一致的物料需二次确认，全部一致则直接提交
        // 申请数量为空或0时不参与比较（不提示）
        var inconsistent = _this7.form.material_arr.filter(function (item) {
          var applyNum = item.apply_num;
          if (applyNum === '' || applyNum === null || applyNum === undefined || Number(applyNum) === 0) return false;
          return String(applyNum) !== String(item.receive_num);
        });
        if (inconsistent.length > 0) {
          var names = inconsistent.map(function (item) {
            return item.name;
          }).join('、');
          _this7.$confirm("<span style=\"color: red\">\u3010".concat(names, "\u3011</span> \u7684\u7533\u8BF7\u6570\u91CF\u548C\u9886\u53D6\u6570\u91CF\u4E0D\u4E00\u81F4\uFF0C\u786E\u5B9A\u8981\u63D0\u4EA4\uFF1F"), '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }).then(function () {
            _this7.doSubmit();
          }).catch(function () {});
          return;
        }
        _this7.doSubmit();
      });
    },
    // 组装参数并调用提交接口
    doSubmit: function doSubmit() {
      var _this8 = this;
      this.submitLoading = true;
      var params = _objectSpread(_objectSpread({}, this.form), {}, {
        material_arr: this.form.material_arr.map(function (item) {
          return {
            id: item.id,
            material_type: item.material_type,
            begin_code: _this8.isCardCoupon(item) ? item.begin_code : '',
            end_code: _this8.isCardCoupon(item) ? item.end_code : '',
            receive_num: Number(item.receive_num) || 0
          };
        })
      });
      if (this.mode === 'edit' && this.row) {
        params.id = this.row.id;
      }
      var api = this.mode === 'add' ? cardManagementCreate : receive;
      api(params).then(function () {
        _this8.$message.success('领卡登记已提交');
        _this8.$emit('emitGetList');
      }).catch(function (err) {}).finally(function () {
        _this8.submitLoading = false;
      });
    },
    handleClose: function handleClose() {
      this.$emit('close');
    }
  }
};